import { render, staticRenderFns } from "./mbHome.vue?vue&type=template&id=547330da&scoped=true"
import script from "./mbHome.vue?vue&type=script&lang=js"
export * from "./mbHome.vue?vue&type=script&lang=js"
import style0 from "./mbHome.vue?vue&type=style&index=0&id=547330da&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "547330da",
  null
  
)

export default component.exports